import { ReactElement } from 'react'

import { FAL_CLOUD_RAIN } from 'const/icons'
import i18n from 'strings/i18n'
import { Inset, Stack } from 'syf-component-library/ui/spacing'
import { H2, H4 } from 'syf-component-library/ui/typography'

import config from 'const/config'
import {
  DisabledCookiesError,
  ErrorCard,
  ErrorWrapper,
  FullPageError,
  NoAccountError,
  RainCloudsIcon,
  TechnicalDifficultiesError,
  TechnicalErrorImage,
  TechnicalErrorImageWrapper,
  TextWrapper
} from './subcomponents'
import { ErrorTypes, TechnicalErrorProp } from './typings'

const TechnicalError = ({ errorType }: TechnicalErrorProp): ReactElement => {
  const errors: Record<ErrorTypes, ReactElement> = {
    disabledCookies: <DisabledCookiesError />,
    technicalError: <TechnicalDifficultiesError />,
    fullPageError: <FullPageError />,
    noAccountsFound: <NoAccountError />
  }

  const hasTechnicalError = errorType === 'technicalError'

  return (
    <ErrorWrapper bottom="xlarge">
      <ErrorCard
        data-test="technical-error"
        hasTechnicalError={hasTechnicalError}
      >
        <TextWrapper hasTechnicalError={hasTechnicalError}>
          {hasTechnicalError ? (
            <>
              <TechnicalErrorImageWrapper>
                <TechnicalErrorImage
                  src={`${config.ASSETS_HOST}/assets/vista/technical_error_cat.svg`}
                  alt={`${i18n({ creditView: 'errorTitle' })}`}
                />
              </TechnicalErrorImageWrapper>
              <Stack size="xlarge" hideOnBreakpointDown="small" />
              <Stack size="large" hideOnBreakpointUp="small" />
              <H4 as="h2" weight="bold" data-test="error-page-header">
                {i18n({ errors: 'weApologize' })}
              </H4>
              <Stack size="base" />
            </>
          ) : (
            <>
              <Inset top="base" hideOnBreakpointDown="large" />
              <Stack size="base" />
              <RainCloudsIcon icon={FAL_CLOUD_RAIN} size="4x" />
              <Inset all="large">
                <H2 weight="light" data-test="error-page-header">
                  {errorType === 'disabledCookies'
                    ? 'Oops, we hit a snag…'
                    : i18n({ errors: 'weApologize' })}
                </H2>
              </Inset>
              <Stack size="small" hideOnBreakpointDown="large" />
            </>
          )}
          {errors[errorType]}
        </TextWrapper>
      </ErrorCard>
    </ErrorWrapper>
  )
}

export default TechnicalError
